import { createSlice } from "@reduxjs/toolkit";

const initialPackageState = {
  grooming: [],  // Array
  walking: [],   // Array
  training: [],  // Array
  boarding: [],  // Array
  doctor: {},    // Object with subTypes
  diet: [],      // Array
};
const initialState = {
  selectedBooking: null,
  bookings: [],  // if you want to store bookings list
};
const packageSlice = createSlice({
  name: "package",
  initialState: initialPackageState,
  reducers: {
    addPackage: (state, action) => {
      const { packageType, subType, newPackage } = action.payload;
      const type = packageType.toLowerCase();

      if (type === "doctor") {
        // doctor is an object with subTypes
        if (!state.doctor[subType]) {
          state.doctor[subType] = [];
        }
        state.doctor[subType].push(newPackage);
      } else {
        // other types are arrays
        state[type].push(newPackage);
      }
    },

    deletePackage: (state, action) => {
      const { packageType, id, subType } = action.payload;
      const type = packageType.toLowerCase();

      if (type === "doctor" && subType) {
        if (state.doctor[subType]) {
          state.doctor[subType] = state.doctor[subType].filter(pkg => pkg.id !== id);
        }
      } else {
        state[type] = state[type].filter(pkg => pkg.id !== id);
      }
    },

    editPackage: (state, action) => {
      const { packageType, subType, updatedPackage } = action.payload;
      const type = packageType.toLowerCase();

      if (type === "doctor" && subType) {
        if (state.doctor[subType]) {
          const index = state.doctor[subType].findIndex(pkg => pkg.id === updatedPackage.id);
          if (index !== -1) {
            state.doctor[subType][index] = updatedPackage;
          }
        }
      } else {
        // for array types (like grooming)
        const index = state[type].findIndex(pkg => pkg.id === updatedPackage.id);
        if (index !== -1) {
          state[type][index] = updatedPackage;
        }
      }
    },

    setInitialPackages: (state, action) => {
      const { packageType, packages } = action.payload;
      const type = packageType.toLowerCase();
      state[type] = packages;
    },
  },
});
const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setSelectedBooking: (state, action) => {
      state.selectedBooking = action.payload;
    },
    // Add other booking reducers if needed
  },
});
export const {
  addPackage,
  deletePackage,
  editPackage,
  setInitialPackages,
} = packageSlice.actions;

export const packageReducer = packageSlice.reducer;
export const { setSelectedBooking } = bookingSlice.actions;
export const bookingReducer = bookingSlice.reducer;